const textStyles = {
    webH1: {
        fontWeight: 'normal',
        textTransform: 'none'
    },
    webH2: {
        fontWeight: 'normal',
        textTransform: 'none'
    },
    webH3: {
        fontWeight: 'normal',
        textTransform: 'none'
    },
    webH4: {
        fontWeight: 'normal',
        textTransform: 'none'
    },
    cta: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 'normal'
    },
    ctaUnderlined: {
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: 'normal'
    },
    ctaOther: {
        fontSize: '16px',
        textTransform: 'none'
    },
    badge: {
        fontWeight: 'normal',
        textTransform: 'capitalize'
    },
    labelXs: {
        lineHeight: {base: '18px', md: '20px', lg: '20px'},
        fontWeight: 'normal'
    },
    labelSmMd: {
        fontWeight: 'normal'
    },
    subtitle: {
        fontWeight: 'normal'
    },
    footer: {
        fontWeight: 'normal'
    },
    webButtonTypography: {
        fontSize: {base: 'webLg'},
        lineHeight: {base: '20px'},
        fontWeight: 'normal',
        textTransform: 'none'
    },
    bodySmBold: {
        fontWeight: 'normal'
    }
}

export {textStyles}
